<template>
    <svg
        class="icon-linkedin fill-current"
        viewBox="0 0 28.208 28.173"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M6.341,28.173H.5V9.365H6.34ZM3.417,6.8A3.4,3.4,0,1,1,6.8,3.383v0A3.412,3.412,0,0,1,3.417,6.8ZM28.2,28.173H22.372V19.017c0-2.182-.044-4.98-3.037-4.98-3.037,0-3.5,2.371-3.5,4.823v9.313H10V9.365h5.6v2.566h.082a6.137,6.137,0,0,1,5.527-3.038c5.911,0,7,3.892,7,8.948V28.173Z" /></svg>
</template>
